/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Dictionary items represent search parameter for cruises-compact search
 * @export
 * @interface DictionaryItem
 */
export interface DictionaryItem {
    /**
     * The code
     * @type {string}
     * @memberof DictionaryItem
     */
    code: string;
    /**
     * The display name
     * @type {string}
     * @memberof DictionaryItem
     */
    name: string;
}

/**
 * Check if a given object implements the DictionaryItem interface.
 */
export function instanceOfDictionaryItem(value: object): value is DictionaryItem {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DictionaryItemFromJSON(json: any): DictionaryItem {
    return DictionaryItemFromJSONTyped(json, false);
}

export function DictionaryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictionaryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
    };
}

export function DictionaryItemToJSON(json: any): DictionaryItem {
    return DictionaryItemToJSONTyped(json, false);
}

export function DictionaryItemToJSONTyped(value?: DictionaryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

